import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod, formatMoney } from "theme";

var _onVariantChangedListenerPaymentTerms, _onVariantChangedPaymentTerms, onVariantChanged_fnPaymentTerms;
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChangedPaymentTerms);
    __privateAdd(this, _onVariantChangedListenerPaymentTerms, __privateMethod(this, _onVariantChangedPaymentTerms, onVariantChanged_fnPaymentTerms).bind(this));
  }
  connectedCallback() {
    document?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListenerPaymentTerms));
  }
  disconnectedCallback() {
    document?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListenerPaymentTerms));
  }
  
  get spendLimit() {
    return this.getAttribute("limit");
  }
  
  get spendLimitLower() {
    return this.getAttribute("limit-lower");
  }
  
};
_onVariantChangedListenerPaymentTerms = new WeakMap();
_onVariantChangedPaymentTerms = new WeakSet();
onVariantChanged_fnPaymentTerms = function(event) {
	console.log(event.detail.variant);
	console.log(this)
  if (event.detail.variant) {
	  if (event.detail.variant["price"] > this.spendLimit || event.detail.variant["price"] < this.spendLimitLower) {
		  this.classList.add('hidden');
	  } else if (this.classList.contains('hidden')) {
		  this.classList.remove('hidden');
	  };
	  this.querySelector('#payment-terms-price')?.replaceChildren(formatMoney(event.detail.variant.price / 4));
  }
};
if (!window.customElements.get("payment-terms-ghd")) {
  window.customElements.define("payment-terms-ghd", PaymentTerms);
}

var AfterpayModalTrigger = class extends HTMLButtonElement {
  constructor() {
    super();
	this.addEventListener("click", (event) => {
		document.querySelector('square-placement').shadowRoot.querySelector('#logo-link').click();
    });
  }
};

if (!window.customElements.get("afterpay-trigger")) {
  window.customElements.define("afterpay-trigger", AfterpayModalTrigger, { extends: "button" });
}

var ZipModalTrigger = class extends HTMLButtonElement {
  constructor() {
    super();
	this.addEventListener("click", (event) => {
		document.querySelector('#zip-product-widget .zip-logo').click();
    });
  }
};

if (!window.customElements.get("zip-trigger")) {
  window.customElements.define("zip-trigger", ZipModalTrigger, { extends: "button" });
}